<template>
  <div>
    <transition name="fade" appear>
      <div v-show="visible" class="app-backdrop" @click="onHide()"></div>
    </transition>
    <div class="modal app-modal" ref="modal" @click.self="onHide()">
      <component
        v-for="(modal, index) in modals"
        :key="index"
        v-show="index == (modals.length - 1)"
        v-bind="modal.props"
        :is="modal.component"
        @hide="onHide"
        @forceHide="onForceHide"
        ref="modals"
        class="app-modal-content"
      />
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'AppModals',
    props: {
      modals: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        visible: false,
      }
    },
    computed: {
      isOpen () {
        return !!this.modals.length
      },
      topModal () {
        return this.modals[this.modals.length - 1]
      },
    },
    watch: {
      isOpen (isOpen) {
        let $modal = $(this.$refs.modal)
        if (isOpen) {
          $('.modal-backdrop').show()
          $modal.show()
          this.visible = true
          $modal.on('hide.bs.modal.modal-stack', this.onBootstrapHide)
        } else {
          $modal.off('hide.bs.modal.modal-stack', this.onBootstrapHide)
          this.visible = false
          $modal.hide()
          $('.modal-backdrop').hide()
        }
      },
      modals () {
        this.$nextTick(() => {
          $(this.$refs.modal).scrollTop(0)
        })
      },
    },
    methods: {
      show (component, props) {
        return new Promise((resolve) => {
          this.modals.push({
            component,
            resolve,
            props,
          })
        })
      },
      onHide (value, force = false) {
        let modalInstance = this.$refs.modals[this.$refs.modals.length - 1]

        let hideModal = () => {
          this.modals[this.modals.length - 1].resolve(value)
          this.modals.splice(this.modals.length - 1, 1)
        }

        if (!force && typeof modalInstance.beforeHide === 'function') {
          let hidePromise = new Promise((resolve, reject) => {
            Promise
              .resolve(modalInstance.beforeHide(reject))
              .then(resolve)
              .catch(reject)
          })

          hidePromise
            .then(hideModal)
            .catch(() => { /* modal hide prevented */ })
        } else {
          hideModal()
        }
      },
      onForceHide (value) {
        this.onHide(value, true)
      },
      onBootstrapHide (e) {
        // Skip other hide events, such as datepicker's
        if (e.namespace === 'bs.modal') {
          e.preventDefault()
          this.onHide()
        }
      },
      closeAll () {
        // todo
      },
    },
  }
</script>
<style lang="scss">
  @import "boot";
  .app-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: $zindex-modal-backdrop;
    background-color: rgba($modal-backdrop-bg, $modal-backdrop-opacity);
  }
  .app-modal-content {}
  .app-modal {
    max-height: 100%;
    overflow-y: auto;
    z-index: $zindex-modal;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/app-modals.vue